import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux';
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import shortid from 'shortid'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import CustomField from '../components/CustomField/CustomField.js'
import Button from '../components/Button/Button.js'
import Doc from '../components/Doc/Doc.js'
import DocThumbnail from '../components/Doc/DocThumbnail.js'
import PatternThumbnail from '../components/PatternThumbnail/PatternThumbnail.js'

import {
  tryToGetOfficialPatterns
} from '../actions/actions.export'

import docLoader from '../docLoader.js'

var pf_config = require('../pf_config.json');
let docSearchTimeout;

class DocsRoute extends Component {

  constructor(props){
    super(props);

    this.state = {
      search: "",
      searching: false
    }

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  componentDidMount(){
    const { dispatch } = this.props;
    window.document.title = "Docs - Pattycake";
    dispatch(tryToGetOfficialPatterns());
  }

  componentDidUpdate(){
    var params = window.location.search.substring(1);

    if(params){
      params = JSON.parse('{"' + decodeURI(params).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
      if(params.search !== this.state.search){
        this.setState({
          search: params.search
        })
      }
    } else if(this.state.search !== ""){
      this.setState({
        search: ""
      })
    }
  }

  handleSearchChange(e){
    const { dispatch } = this.props;

    this.setState({
      search: e
    })
  }

  render(){
    const { user, docs, patternManager } = this.props;


    let specificDoc = docLoader.dictionary[this.props.match.params.slug];
    
    
    let category;
    let categorySlug = this.props.match.params.categorySlug;
    if(categorySlug){
      category = docLoader.categories.filter(d => d.slug == categorySlug);
      // flatten
      if(category) category = category[0];
    }


    let tag;
    let tagSlug = this.props.match.params.tagSlug;
    if(tagSlug){
      tag = docLoader.tags.filter(d => d.name == tagSlug);
      // flatten
      if(tag) tag = tag[0];
    }


    let search_results = [];
    if(this.state.search){
      search_results = docLoader.list
        .filter((d) => { 
          return d.title.toLowerCase().indexOf(this.state.search.trim()) > -1 || d.tags.join('').indexOf(this.state.search.trim()) > -1;
        })
        .map((d, i) => {
          return <div className="col-md-4" key={i}>
            <DocThumbnail doc={d}/>
          </div>  
        })
    }


    return <div className="_content-wrapper">
    
      <div className="_home">
        <div className="_docs">

          <Header/>
          <div className="container">
            <div className="row row-mega-padded">
              
              <div className="col-md-12">
                
                {
                  (specificDoc && !this.state.search) && <Doc doc={specificDoc}/>
                }

                {
                  (category && !this.state.search) &&
                  <div>
                    <div>docs by category...</div>
                    <h1>{category.name}</h1>
                    <div className="row">
                      {
                        docLoader.list.filter(d => d.category.slug == category.slug).map((d, i) => {
                          return <div className="col-md-4" key={i}>
                            <DocThumbnail doc={d}/>
                          </div>  
                        })
                      }
                    </div>
                  </div>
                }

                {
                  (tag && !this.state.search) &&
                  <div>
                    <div>docs tagged with...</div>
                    <h1>{tag.name}</h1>
                    <div className="row">
                      {
                        docLoader.list.filter(d => d.tags.indexOf(tag.name) > -1).map((d, i) => {
                          return <div className="col-md-4" key={i}>
                            <DocThumbnail doc={d}/>
                          </div>  
                        })
                      }
                    </div>
                  </div>
                }

                {
                  (this.state.search) &&
                  <div className="row">
                    <div className="col-md-12">
                      <div>searching for...</div>
                      <h1>{this.state.search}</h1>
                    </div>
                    {
                      search_results.length > 0 ?
                      search_results
                      :
                      <div className="col-md-12">
                        <p>No docs found based on this search.</p>
                      </div>
                    }
                    <div className="col-md-12">
                      <hr className="hr-mega-pad"/>
                      <h4 className="text-center">Looking for more?</h4>
                      <p className="lead text-center">Here are a few docs you might find interesting:</p>
                      <div className="row row-eq-height">
                        {
                          docLoader.list.slice(0,6).map((dd, j)=> {
                            return <div className="col-md-4" key={j}> 
                              <DocThumbnail doc={dd}/>
                            </div>
                          })
                        }
                      </div>
                    </div>
                  </div>
                }

                {
                  (!specificDoc && !categorySlug && !tagSlug && !this.state.search) &&
                  <div>
                    <h1>Docs</h1>
                    <p className="lead">
                      Whether you're a .pat file expert or just looking for a quick solution,<br/>learn how to get what you need from Pattycake to make your drawings better than ever.
                    </p>
                    <hr/>
                    <h4>
                      Don't know where to begin?
                    </h4>
                    <p>
                      Here are a few articles to help you get started:
                    </p>
                    <div className="row row-eq-height">
                      <div className="col-md-4">
                        <DocThumbnail doc={docLoader.dictionary['what-is-a-pat-file']}/>
                      </div>
                      <div className="col-md-4">
                        <DocThumbnail doc={docLoader.dictionary['pat-file-syntax-and-rules']}/>
                      </div>
                      <div className="col-md-4">
                        <DocThumbnail doc={docLoader.dictionary['pat-from-scratch-intro-tutorial']}/>
                      </div>
                      <div className="col-md-4">
                        <DocThumbnail doc={docLoader.dictionary['five-benefits-of-pat-files']}/>
                      </div>
                    </div>

                    <hr/>
                    <h4>
                      Need help? Just ask.
                    </h4>
                    <p>
                      We spend a lot of time answering pattern related questions for Pattycake and beyond. Here are a few of our public conversations and frequent questions archived for reference.
                    </p>
                    <div className="row row-eq-height">
                      <div className="col-md-4">
                        <DocThumbnail doc={docLoader.dictionary['qa-batt-insulation-pattern']}/>
                      </div>
                      <div className="col-md-4">
                        <DocThumbnail doc={docLoader.dictionary['qa-how-to-create-that-pattern-in-revit']}/>
                      </div>
                      <div className="col-md-4">
                        <DocThumbnail doc={docLoader.dictionary['qa-revit-pat-files-not-recognized']}/>
                      </div>
                      <div className="col-md-4">
                        <DocThumbnail doc={docLoader.dictionary['qa-rotating-direction-of-filled-region']}/>
                      </div>
                      <div className="col-md-4">
                        <DocThumbnail doc={docLoader.dictionary['qa-staggered-running-bond-hatch-pattern']}/>
                      </div>
                      <div className="col-md-4">
                        <DocThumbnail doc={docLoader.dictionary['qa-no-model-type-patterns-found']}/>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <Footer/>
        </div>
      </div>
    </div>
  }
}

DocsRoute = reduxForm({
  form: 'DocsRouteForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(DocsRoute)

DocsRoute = connect((state, ownProps) => {
  const { user, patternManager } = state;

  var initialValues = {
    search: ""
  };
  
  return {
    user,
    patternManager,
    initialValues
  }
})(DocsRoute);

export default DocsRoute;


// WEBPACK FOOTER //
// ./src/routes/Docs.js